export class publicHoliday {
    public id: number;
    public name: string;
    public year: number;
    beginDate: Date;
    public endDate: Date;
    public dueInDays: number;

}